import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";

import { OperationFilters, OperationOptions } from "../types";

interface OperationsFiltersProps {
  filters: OperationFilters;
  options: OperationOptions;
  onChange: (filters: Partial<OperationFilters>) => void;
  onReset: () => void;
}

const statuses = [
  "PENDING",
  "REQUESTED",
  "APPROVED",
  "DISPATCHED",
  "RECEIVED",
  "VERIFIED",
  "ISSUED",
  "COMPLETED",
  "CANCELLED",
  "REJECTED",
];

const OperationsFilters = ({
  filters,
  options,
  onChange,
  onReset,
}: OperationsFiltersProps) => (
  <Paper
    elevation={0}
    sx={(theme) => ({
      p: { xs: 1.5, md: 1.75 },
      border: "1px solid",
      borderColor: theme.palette.mode === "dark" ? "#2a3953" : "divider",
      borderRadius: 2,
      bgcolor: theme.palette.mode === "dark" ? "#111b2d" : "background.paper",
    })}
  >
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          size="small"
          label="Search operations"
          placeholder="Search operations, code, or reference..."
          value={filters.search}
          onChange={(event) => onChange({ search: event.target.value })}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={2.5}>
        <FormControl fullWidth size="small">
          <InputLabel>Status</InputLabel>
          <Select
            label="Status"
            value={filters.status}
            onChange={(event) => onChange({ status: event.target.value })}
          >
            <MenuItem value="">All Statuses</MenuItem>
            {statuses.map((status) => (
              <MenuItem value={status} key={status}>
                {status}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={2.5}>
        <FormControl fullWidth size="small">
          <InputLabel>Hub</InputLabel>
          <Select
            label="Hub"
            value={filters.warehouseId}
            onChange={(event) => onChange({ warehouseId: event.target.value })}
          >
            <MenuItem value="">All Hubs</MenuItem>
            {options.hubs.map((hub) => (
              <MenuItem value={hub.id} key={hub.id}>
                {hub.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <FormControl fullWidth size="small">
          <InputLabel>Technician</InputLabel>
          <Select
            label="Technician"
            value={filters.technicianId}
            onChange={(event) => onChange({ technicianId: event.target.value })}
          >
            <MenuItem value="">All Technicians</MenuItem>
            {options.technicians.map((technician) => (
              <MenuItem value={technician.id} key={technician.id}>
                {technician.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={1}>
        <Button fullWidth variant="outlined" startIcon={<RestartAltRoundedIcon />} onClick={onReset} sx={{ height: 42 }}>
          Reset
        </Button>
      </Grid>
    </Grid>
  </Paper>
);

export default OperationsFilters;
